export default __webpack_public_path__ + "static/1657-a1051056f1e7dddda699db43ab707930.gif";